import { PlayCircleFilled } from '@ant-design/icons'
import { appConfig } from 'Config/app-config'
import { ReactNode } from 'react'
import { getSignedOrPublicURL } from 'Services/tasks.service'
import styles from './VideoCard.module.less'
import { useQuery } from '@tanstack/react-query'

type VideoCardProps = {
    title: string
    description?: string
    extra?: ReactNode
}

export const VideoCard: React.FC<VideoCardProps> = ({ title, description, extra }) => {
    const { data: videoUrl } = useQuery({
        queryKey: ['examIntroVideo'],
        queryFn: () =>
            getSignedOrPublicURL(
                `${appConfig.envFtsPrivateStaticAssetsDistributionUrl}FTS-Exam-Demo.mp4`
            ),
        staleTime: Infinity,
    })

    return (
        <div className={styles['video-card']}>
            {videoUrl ? (
                <div className={styles['thumbnail']}>
                    <video controlsList="nodownload" controls width="100%" height="140px">
                        <source src={videoUrl} type="video/mp4" />
                        Your browser does not support the video.
                    </video>
                </div>
            ) : (
                <div className={styles['empty-thumbnail']}>
                    <PlayCircleFilled className={styles['play-icon']} />
                </div>
            )}
            <p className={styles['title']}>{title}</p>
            {description && <p className={styles['description']}>{description}</p>}
            {extra && <div className={styles['extra']}>{extra}</div>}
        </div>
    )
}
